import React, { useEffect } from 'react'
import {
  Card,
  CardActions,
  Typography,
  CardContent,
  IconButton,
  Grid,
  Stack,
} from '@mui/material'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import { useLang } from '~/hooks/useLang'
import useEntryState from '~/features/Entry/stores/EntryState'
import Close from '@mui/icons-material/Close'
import useMapState, { useMarkerState } from '~/features/Map/stores/MapState'
import { useHookstate } from '@hookstate/core'

export default function MarkerPopupContentEntry({
  id,
  location,
  readonly,
  typeId,
  subtypeId,
  typeSubtype,
  closeThisPopUp,
}) {
  const { translate } = useLang()
  const { getEntryFromId } = useEntryState()
  const { markers } = useMapState();
  const { forceClosePopup } = useMarkerState()
  const entryState = useEntryState();
  const { saved } = entryState.entry();

  const existMarker = useHookstate<string[]>([])


  const handleImportEntry = ({ entryId }) => {
    getEntryFromId(entryId).finally(() => {
      saved.set(true)
    })
  }

  useEffect(() => {
    existMarker.set(Object.keys(markers()['entry'].get()).filter((item) => item == String(id)))
    if (!existMarker.get().length) {
      closeThisPopUp()
    }

  }, [forceClosePopup.get()])

  return (
    <Card
      sx={{
        backgroundColor: 'transparent',
        backgroundImage: 'none',
        boxShadow: 'none',
      }}
    >
      <CardContent sx={{ padding: '1em 0 1em 0', textAlign: 'center' }}>
        <Stack direction="row" alignItems="center" gap={2} justifyContent={'flex-end'}>
          <Typography
            className="popupText-dark"
            variant="subtitle1"
            sx={{ margin: '.6em 0' }}
          >
            <b>{translate('Entry') + ` ${id}`}</b>{' '}
          </Typography>
          <IconButton size="small" onClick={() => closeThisPopUp()}>
            <Close fontSize="small" />
          </IconButton>
        </Stack>
        <Typography
          className="popupText-dark"
          variant="subtitle1"
          sx={{ margin: '.6em 0' }}
        >
          {' '}
          {typeSubtype}
        </Typography>
        <Typography
          className="popupText-dark"
          variant="subtitle1"
          sx={{ margin: '.6em 0' }}
        >
          {' '}
          {location}
        </Typography>
      </CardContent>
      {!readonly ? (
        <CardActions sx={{ padding: 0, justifyContent: 'center' }}>
          <IconButton
            title='Abrir Atendimento'
            className="popupButton"
            color="primary"
            sx={{ cursor: 'pointer' }}
            onClick={() => handleImportEntry({ entryId: id })}
          >
            <FileUploadIcon />
          </IconButton>
        </CardActions>
      ) : (
        false
      )}
    </Card>
  )
}
function entryStatusActions(): { canSave: any } {
  throw new Error('Function not implemented.')
}

